import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
    name: 'mathCeil'
}) export class MathCeilPipe implements PipeTransform {
    transform(value: number) {
        return Math.ceil(value);
    }
}
